import { IStyle } from '@fluentui/react';
import { IH2OTheme } from '@h2oai/ui-kit';

export interface IEditFeatureSetPanelStyles {
  root?: IStyle;
}

export interface IEditFeatureSetPanelClassNames {
  root: string;
}

export const editFeatureSetPanelStylesDefault = (_theme: IH2OTheme): Partial<IEditFeatureSetPanelStyles> => ({
  root: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
});
